<mat-expansion-panel class="groupFeatureCard" [expanded]="true">
    <mat-expansion-panel-header class="panel-height">
        <mat-panel-title>
            @if (showOrderControls) {
                <div class="order-controls-inline">
                    <button *ngIf="canMoveUp" mat-icon-button (click)="onMoveUp(); $event.stopPropagation()"
                        [disabled]="!canMoveUp" matTooltip="Nach oben" class="order-button-small">
                        <mat-icon>keyboard_arrow_up</mat-icon>
                    </button>
                    <button *ngIf="canMoveDown" mat-icon-button (click)="onMoveDown(); $event.stopPropagation()"
                        [disabled]="!canMoveDown" matTooltip="Nach unten" class="order-button-small">
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>
                </div>
            }
            <div class="flexContainer">
                <div class="groupName">
                    @if (position < 3) {
                        <span class="top-label">
                            TOP {{ position + 1 }}:
                        </span>
                    }
                    <span>
                        {{ ptgName}}
                    </span>
                </div>
                <!-- <mat-icon
                        class="info-icon"
                        *ngIf="ptg.ptgDescription != ''"
                        matTooltip="{{ ptg.ptgDescription }}"
                    >
                        info_outline
                    </mat-icon> -->
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="group-feature-list">
        <div>
            <div class="attributeRow header-line">
                <span></span>
                <mat-checkbox [(ngModel)]="allSelected" (change)="toggleAllAttributes($event.checked)"
                    (click)="$event.stopPropagation()">
                </mat-checkbox>
                <!-- <div style="height: 1px; width: 21px;"></div> -->
            </div>
            <div *ngFor="let attribute of attributes">
                <div class="attributeRow">
                    <div class="attribute-name">
                        <p *ngIf="!optional">
                            {{ attribute.name }}
                        </p>
                        <p *ngIf="optional">{{ attribute.name }} (optional)</p>
                        <mat-icon *ngIf="attribute.description" [matTooltip]="attribute.description"
                            matTooltipPosition="above" class="info-tooltip-icon"
                            tabindex="-1">info_outline</mat-icon>
                    </div>
                    <div>
                        <!-- <checkbox-switch
                        id="{{ attribute.id }}"
                        [disableToggle]="hasAttributeConflict(attribute)"
                        [value]="attributeValidationService.activeEntityFeatureValues.get(attribute.id) === 'true'"
                        (valueChange)="onAttributeValueChange(attribute, $event ? 'true' : 'false')"
                        >
                        </checkbox-switch> -->
                        <checkbox-switch id="{{ attribute.id }}"
                            [value]="attributeValidationService.activeEntityFeatureValues.get(attribute.id) === 'true'"
                            (valueChange)="onAttributeValueChange(attribute, $event ? 'true' : 'false')">
                        </checkbox-switch>
                    </div>

                    <!-- <div>
                        <validation-icon
                            [value]="
                                attributeValidationService.attributesValidated.get(
                                    attribute.id
                                )
                            "
                        ></validation-icon>
                    </div> -->

                    <!-- Noch mal prüfen in welchen Szenarien das vorkommt! -->

                    <!-- <div *ngIf="editable">
                        <red-cross-button
                            (click)="removeAttribute(attribute)"
                        ></red-cross-button>
                    </div> -->
                </div>
                <!-- <div *ngIf="hasAttributeConflict(attribute)" class="conflict-error">
                    {{ getConflictErrorMessage(attribute) }}
                </div> -->
            </div>
        </div>
    </div>
</mat-expansion-panel>